




































































































































import {Component, Vue} from "vue-property-decorator";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import LadingCodeSearch from "./components/Search/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import LadingCodePrint from "@/modules/ladingcodes/shared/components/LadingCodePrint/index.vue";
import {Options} from "@/plugins/print/lib/print";
import {getPublicPath} from "@/shared/services/helper/utils";
import LadingCodeStatusLabel from "@/modules/ladingcodes/List/components/StatusLabel/index.vue";
import LadingCodePrintStatusLabel from "@/modules/ladingcodes/List/components/StatusPrintLabel/index.vue";
import LadingCodeA7Print from "@/modules/ladingcodes/shared/components/LadingCodeA7Print/index.vue";
import PrintLading from "@/modules/ladings/Print/index.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import {LadingStore} from "@/modules/ladings/store";
import {debounce} from "lodash";

@Component({
    name: "LadingCodeList",
    components: {
        PrintLading,
        LadingCodeA7Print,
        LadingCodePrintStatusLabel,
        LadingCodeStatusLabel,
        LadingCodePrint,
        LadingCodeSearch,
        CommonStatusLabel,
        LadingStatusLabel,
        TooltipLabel,
        AInputBarCode
    }
})
export default class extends mixins(CommonMixin) {
    selectedIds = [];
    columns = [
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "ladingCode"}
        },
        {
            title: "Vận đơn ĐT",
            dataIndex: "partnerLadingCode",
            key: "partnerLadingCode",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "partnerLadingCode"}

        },
        {
            title: "SDT người nhận",
            dataIndex: "locationTo.phoneNumber",
            key: "locationToPhone",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "locationToPhoneNumber"}

        },
        {
            title: "Tên người nhận",
            dataIndex: "locationTo.name",
            key: "locationToName",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "locationToName"}

        },
        {
            title: "Địa chỉ",
            dataIndex: "locationTo",
            key: "locationToAddress",
            scopedSlots: {customRender: "locationToAddress"},
            width: 500,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        // {
        //     title: "Loại đơn",
        //     dataIndex: "type",
        //     key: "type",
        //     scopedSlots: {customRender: 'type'},
        //     width: 150,
        //     ellipsis: true
        // }
    ];
    visible = false;
    printObj: Options = {
        id: 'print-lading-code',
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };

    ladingCode = '';

    created() {
        LadingStore.clearData();
        LadingStore.clearDataCached();
    }

    get ladings() {
        return LadingStore.ids.map((id: string) => LadingStore.data[id]);
    }

    onSelectedIdsChange(selectedIds: any) {
        this.selectedIds = selectedIds;
    }

    onChangeLadingCode(evt: any) {
        const val = evt.target.value;

        if (!val) return;

        this.handleChangeLadingCode(val, this);
    }

    handleChangeLadingCode = debounce(async (ladingCode: any, vm: any) => {
        try {
            await LadingStore.singleLadingByCode(ladingCode);
        } catch (e) {
            console.log(e);
            vm.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        } finally {
            vm.ladingCode = '';
        }
    }, 500);
}
